import React from 'react'
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../styles/redes.css"

function Redes2() {
  return (
    <nav className="social ">
        <ul>
            <li className='social-whatsapp-li'>
              <a className='social-a social-whatsapp-a' href="https://wa.me/3188217116" target='blank'>
                WhatsApp <i className="social-whatsapp fab fa-whatsapp"></i>
              </a>
            </li>
            <li className='social-facebook-li'>
              <a className='social-a social-facebook-a' href="https://www.facebook.com/profile.php?id=61552338819531" target='blank'>
                Facebook <i className="social-facebook fab fa-facebook"></i>
              </a>
            </li>
            <li className='social-instagram-li'>
              <a className='social-a social-instagram-a' href="https://www.instagram.com/impuestosmunicipales23" target='blank'>
                Instagram <i className="social-instagram fab fa-instagram"></i>
              </a>
            </li>
            <li className='social-twitter-li'>
              <a className='social-a social-twitter-a' href="https://twitter.com/Tributos23" target='blank'>
                Twitter <i className="social-twitter fab fa-twitter"></i>
              </a>
            </li>
            <li className='social-linkedin-li'>
              <a className='social-a social-linkedin-a' href="https://www.linkedin.com/in/administraci%C3%B3n-tributaria-793328297" target='blank'>
                LinkedIn <i className="social-linkedin fab fa-linkedin"></i>
              </a>
            </li>
            <li className='social-youtube-li'>
              <a className='social-a social-youtube-a' href="https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w" target='blank'>
                YouTube <i className="social-youtube fab fa-brands fa-youtube"></i>
              </a>
            </li>
            <li className='social-tiktok-li'>
              <a className='social-a social-tiktok-a' href="https://www.tiktok.com/nommbreusuario" target='blank'>
                TikTok <i className="social-tiktok fab fa-tiktok"></i>
              </a>
            </li>
        </ul>
    </nav>
  )
}

export default Redes2